<template>
  <de-layout-content>
    <el-tabs v-model="activeName" @tab-click="changeTab">
      <el-tab-pane label="操作日志" name="operateLog">
        <!-- 改版后 -->
        <div>
          <el-form ref="queryParamsForm" :model="controlsParams" :inline="true" class="ant-advanced-search-form" size="small">
            <el-form-item label="操作用户:" prop="operatorKeyword">
              <el-input
                v-model="controlsParams.operatorKeyword"
                placeholder="操作用户"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="操作时间:" prop="time">
              <el-date-picker
                v-model="controlsParams.time"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="所属机构：" prop="organizationId">
              <el-select v-model="controlsParams.organizationId"  placeholder="选择所属机构">
                <el-option v-for="item in treeList" :key="item.label" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="操作类型:" prop="operationCategoryMenuId">
              <el-select
                v-model="controlsParams.operationCategoryMenuId"
                placeholder="操作类型"
                clearable
                :popper-append-to-body="true"
              >
                <el-option v-for="(item, index) in operateType" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
<!--            <el-form-item label="所属模块:" prop="sourceType">-->
<!--              <el-select-->
<!--                v-model="controlsParams.sourceType"-->
<!--                placeholder="所属模块"-->
<!--                clearable-->
<!--                :popper-append-to-body="true"-->
<!--              >-->
<!--                <el-option v-for="(item, index) in sourceType" :key="index" :label="item.name" :value="item.value" />-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleQuery" >查询 </el-button>
              <el-button icon="el-icon-refresh-left" @click="resetQuery('queryParamsForm')" >重置</el-button >
<!--              <el-button type="" icon="el-icon-download" @click="exportConfirm" >导出数据 </el-button>-->
            </el-form-item>
            <div>

            </div>
          </el-form>
        </div>

        <div>
          <el-table :data="logList" v-loading="loading" element-loading-text="加载中" @selection-change="handleSelectionChange">
            <el-table-column label="操作编号" type="index" align="center" width="100" />
            <el-table-column label="操作用户姓名" prop="operatorName" align="center" />
            <el-table-column label="用户账号" prop="userAccount" align="center" />
            <el-table-column label="所属机构" prop="organizationName" align="center" show-overflow-tooltip />
            <el-table-column prop="operationTime" label="操作时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.operationTime | timestampFormatDate }}
              </template>
            </el-table-column>
            <el-table-column label="操作模块" prop="parentMenuName" align="center" />
            <el-table-column label="操作分类" prop="operationCategoryMenuName" align="center" />
            <el-table-column label="操作内容" prop="operationContent" align="center" width="300px">
                    <template slot-scope="scope">
                        <span class="cp" style="display: block;text-align: center;width: 280px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;" @click="showContent(scope.row.operationContent)">{{ scope.row.operationContent }}</span>
                    </template>
                </el-table-column>
            <el-table-column label="登录IP" prop="operIp" align="center" show-overflow-tooltip />
            <el-table-column label="状态" prop="status" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">成功</span>
                <span v-if="scope.row.status == 1">失败</span>
              </template>
            </el-table-column>
            <el-table-column label="端口" prop="clientType" align="center" show-overflow-tooltip />
          </el-table>

          <pagination :total="controlTotal" :page.sync="controlsParams.pageNum" :limit.sync="controlsParams.pageSize" @pagination="getControlsData" />
        </div>
      </el-tab-pane>

      <el-tab-pane label="登录日志" name="loginLog">
        <el-form :model="loginParams" ref="queryLoginForm" :inline="true" class="ant-advanced-search-form" size="small">
          <el-form-item label="登录用户:" prop="userKeyword">
            <el-input
              v-model="loginParams.userKeyword"
              placeholder="用户姓名/账号"
              clearable
              @keyup.enter.native="handleQueryLogin"
            />
          </el-form-item>
          <el-form-item label="操作时间:" prop="time">
            <el-date-picker
              v-model="loginParams.time"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="-"
              start-placeholder="选择日期"
              end-placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="所属机构：">
            <el-select>
              <el-option></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQueryLogin" >查询 </el-button>
            <el-button icon="el-icon-refresh-left" @click="resetQueryLogin('queryLoginForm')" >重置</el-button >
          </el-form-item>
        </el-form>
        <el-table
          :data="loginList"
          v-loading="loading"
          element-loading-text="加载中"
        >
          <el-table-column label="序号" type="index" width="100" align="center" ></el-table-column>
          <el-table-column prop="operatorName" label="操作用户姓名" align="center" ></el-table-column>
          <el-table-column prop="userAccount" label="用户账号" align="center" ></el-table-column>
          <el-table-column prop="organizationName" label="所属机构" align="center" ></el-table-column>
          <el-table-column prop="operationTime" label="操作时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.operationTime | timestampFormatDate }}
            </template>
          </el-table-column>
          <el-table-column prop="loginIp" label="登录IP" align="center" ></el-table-column>
          <el-table-column prop="loginStatus" label="状态" align="center">
            <template slot-scope="scope">
              <span class="loginSut1" v-if="scope.row.loginStatus == 1"> 成功 </span>
              <span v-else> 失败 </span>
            </template>
          </el-table-column>
          <el-table-column prop="terminalType" label="端口" align="center"></el-table-column>
        </el-table>

        <pagination :total="loginTotal" :page.sync="loginParams.pageNum" :limit.sync="loginParams.pageSize" @pagination="getLoginData" />
      </el-tab-pane>
    </el-tabs>
  </de-layout-content>
</template>

<script>

import GridTable from "@/components/gridTable/index.vue";
import filterUser from "./FilterUser";
import _ from "lodash";
import keyEnter from "@/components/msgCfm/keyEnter.js";
import { buildParam } from "@/utils/GridConditionUtil";
import { addOrder, formatOrders } from "@/utils/index";
import moment from "moment";
// import * as API_Log from "@/api/system/log";
import { logGrid, exportExcel, loginTraceList, bizOperationLogList ,bizOperationCategoryOptions } from "@/api/system/log";
import {structureList} from "@/api/system/mechanism";
export default {
  components: { GridTable, filterUser },
  mixins: [keyEnter],
  data() {
    return {
      activeName: "operateLog",
      loading: false,
      loginList: [],
      logList: [],
      // 操作日志
      controlsParams: {
        operatorKeyword: null,
        operationCategoryMenuId: null,
        organizationId: null,
        time: [],
        pageNum: 1,
        pageSize: 15,
      },
      controlTotal: 0,
      // 登录日志
      loginParams: {
        userKeyword: null,
        time: [],
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10,
      },
      loginTotal: 0,
      operateType: [],
      sourceType: [
        { value: 1, name: '数据源' },
        { value: 2, name: '数据集' },
        { value: 3, name: '仪表板' },
        { value: 4, name: '视图' },
        { value: 5, name: '分享' },
        { value: 6, name: '用户' },
        { value: 7, name: '部门' },
        { value: 8, name: '角色' },
        { value: 9, name: '驱动' },
        { value: 10, name: '解除绑定' },
        { value: 11, name: '菜单' },
        { value: 12, name: 'APIkey' },
      ],
      treeList: []
    };
  },
  created() {
    this.getControlsData();
    this.getSelectData()
    this.getStructureList()
  },
  methods: {
    moment,
    getStructureList() {
      structureList({
        name: undefined,
        status: 1,
      }).then((res) => {
        this.treeList = res.data;
      });
    },
    getSelectData(){
      bizOperationCategoryOptions({}).then(res => {
        if(res.code == 200){
          this.operateType = res.data
        }
      })
    },
    // 接口-操作日志
    getControlsData() {
      let params = {
        operatorKeyword: this.controlsParams.operatorKeyword,
        operationCategoryMenuId: this.controlsParams.operationCategoryMenuId,
        organizationId: this.controlsParams.organizationId,
        startTime: this.controlsParams.time && this.controlsParams.time.length > 0 ? moment(this.controlsParams.time[0]).valueOf() : '',
        endTime: this.controlsParams.time && this.controlsParams.time.length > 0 ? moment(this.controlsParams.time[1]).valueOf() : '',
        pageNum: this.controlsParams.pageNum,
        pageSize: this.controlsParams.pageSize,
      };
      bizOperationLogList(params).then(res => {
        if(res.code == 200){
          this.logList = res.data.list
          this.controlTotal = res.data.total
        }
      })
    },
    // 接口-登录日志
    getLoginData() {
      let params = {
        ...this.loginParams,
        startTime: this.loginParams.time.length ? moment(this.loginParams.time[0]).valueOf() : "",
        endTime: this.loginParams.time.length ? moment(this.loginParams.time[1]).valueOf() : "",
      };
      loginTraceList(params).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.loginList = res.data.list || [];
          this.loading = false;
          this.loginTotal = res.data.total;
        }
      });
    },
    handleQuery() {
      this.controlsParams.pageNum = 1;
      this.getControlsData();
    },
    resetQuery(formName) {
      this.controlsParams.pageNum = 1;
      this.$refs[formName].resetFields();
      this.getControlsData();
    },
    handleQueryLogin() {
      this.loginParams.pageNum = 1;
      this.getLoginData();
    },
    resetQueryLogin(formName) {
      this.loginParams.pageNum = 1;
      this.$refs[formName].resetFields();
      this.getLoginData();
    },
    // 导出
    exportConfirm() {
      this.$confirm(this.$t("log.confirm"), "", {
        confirmButtonText: this.$t("commons.confirm"),
        cancelButtonText: this.$t("commons.cancel"),
        type: "warning",
      })
        .then(() => {
          this.exportData();
        })
        .catch(() => {});
    },
    exportData() {
      // const param = buildParam(this.controlsParams, this.nickName);
      // console.log(param, "param");
      // param.orders = formatOrders(this.controlsParams);
      exportExcel(this.controlsParams).then((res) => {
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.download = "操作日志.xlsx"; // 下载的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    changeTab(e) {
      if (e.name == "operateLog") {
        this.getControlsData();
      } else if (e.name == "loginLog") {
        this.getLoginData();
      }
    },
        showContent(content){
            const htmlContent = `<div style="width: 100%;word-wrap: break-word;">${content}</div>`
            this.$alert(htmlContent,'操作内容',{
                showConfirmButton: false,
                dangerouslyUseHTMLString: true
            })
        },
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  height: 550px;
}

.loginSut1 {
  color: #67c23a;
}

// .table-container-filter {
//   height: calc(100% - 110px);
// }
</style>
